"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    "hljs": {
        "display": "block",
        "overflowX": "auto",
        "padding": "0.5em",
        "color": "#dccf8f",
        "background": "url(./pojoaque.jpg) repeat scroll left top #181914"
    },
    "hljs-comment": {
        "color": "#586e75",
        "fontStyle": "italic"
    },
    "hljs-quote": {
        "color": "#586e75",
        "fontStyle": "italic"
    },
    "hljs-keyword": {
        "color": "#b64926"
    },
    "hljs-selector-tag": {
        "color": "#b64926"
    },
    "hljs-literal": {
        "color": "#b64926"
    },
    "hljs-addition": {
        "color": "#b64926"
    },
    "hljs-number": {
        "color": "#468966"
    },
    "hljs-string": {
        "color": "#468966"
    },
    "hljs-doctag": {
        "color": "#468966"
    },
    "hljs-regexp": {
        "color": "#468966"
    },
    "hljs-title": {
        "color": "#ffb03b"
    },
    "hljs-section": {
        "color": "#ffb03b"
    },
    "hljs-built_in": {
        "color": "#ffb03b"
    },
    "hljs-name": {
        "color": "#ffb03b"
    },
    "hljs-variable": {
        "color": "#b58900"
    },
    "hljs-template-variable": {
        "color": "#b58900"
    },
    "hljs-class .hljs-title": {
        "color": "#b58900"
    },
    "hljs-type": {
        "color": "#b58900"
    },
    "hljs-tag": {
        "color": "#b58900"
    },
    "hljs-attribute": {
        "color": "#b89859"
    },
    "hljs-symbol": {
        "color": "#cb4b16"
    },
    "hljs-bullet": {
        "color": "#cb4b16"
    },
    "hljs-link": {
        "color": "#cb4b16"
    },
    "hljs-subst": {
        "color": "#cb4b16"
    },
    "hljs-meta": {
        "color": "#cb4b16"
    },
    "hljs-deletion": {
        "color": "#dc322f"
    },
    "hljs-selector-id": {
        "color": "#d3a60c"
    },
    "hljs-selector-class": {
        "color": "#d3a60c"
    },
    "hljs-formula": {
        "background": "#073642"
    },
    "hljs-emphasis": {
        "fontStyle": "italic"
    },
    "hljs-strong": {
        "fontWeight": "bold"
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-syntax-highlighter/dist/styles/pojoaque.js
// module id = 310
// module chunks = 0